/* @flow */
import { Model } from 'caldera-immutable-model';
import TimelineEvent from '../../models/TimelineEvent';
import TimelineEventCollection from '../../models/TimelineEventCollection';

import type { TimelineEventObject } from './types';

type TimelineEventConvertible = TimelineEventObject | TimelineEvent;
type TimelineEventCollectionConvertible = TimelineEventObject[]
  | TimelineEvent []
  | TimelineEventCollection;

export default class TimelineState extends Model {

  _events: TimelineEventCollection;
  _defaultEvents: TimelineEventCollection;
  _activeEvent: ?TimelineEvent;

  constructor(data: any) {
    super(data);
    this._events = new TimelineEventCollection(this.get('events'));
    this._defaultEvents = new TimelineEventCollection(this.get('defaultEvents'));
    const activeEvent = this.get('activeEvent');
    this._activeEvent = activeEvent ? new TimelineEvent(activeEvent) : null;
  }

  // Events

  get events(): TimelineEventCollection {
    return this._events;
  }

  setEvents(events: ?TimelineEventCollectionConvertible): TimelineState {
    return this.set('events', events);
  }

  addOrReplaceEvent(event: TimelineEventConvertible): TimelineState {
    return this.setEvents(this.events.addOrReplaceById(event.id || event.uid, event));
  }

  // Default Events

  get defaultEvents(): TimelineEventCollection {
    return this._defaultEvents;
  }

  setDefaultEvents(defaultEvents: ?TimelineEventCollectionConvertible): TimelineState {
    return this.set('defaultEvents', defaultEvents);
  }

  // Fetching events

  get isFetchingEvents(): boolean {
    return !!this.get('isFetchingEvents');
  }

  setIsFetchingEvents(isFetching: boolean): TimelineState {
    return this.set('setIsFetchingEvents', isFetching);
  }

  // Fetching default events

  get isFetchingDefaultEvents(): boolean {
    return !!this.get('isFetchingDefaultEvents');
  }

  setIsFetchingDefaultEvents(isFetching: boolean): TimelineState {
    return this.set('setIsFetchingDefaultEvents', isFetching);
  }

  // Creating event

  get isCreatingEvent(): boolean {
    return !!this.get('isCreatingEvent');
  }

  setIsCreatingEvent(isCreating: boolean): TimelineState {
    return this.set('isCreatingEvent', isCreating);
  }

  // Updating event

  get isUpdatingEvent(): boolean {
    return !!this.get('isUpdatingEvent');
  }

  setIsUpdatingEvent(isUpdating: boolean): TimelineState {
    return this.set('isUpdatingEvent', isUpdating);
  }

  // Active event

  get activeEvent(): ?TimelineEvent {
    return this._activeEvent;
  }

  setActiveEvent(event: TimelineEventConvertible): TimelineState {
    return this.set('activeEvent', event);
  }
}



// WEBPACK FOOTER //
// ./src/redux/timeline/TimelineState.js